(function () {
  'use strict';

  var PROPERTY_NAME = '_tortli_artwork_image';
  var PROPERTY_SELECTOR = 'input[name="properties[' + PROPERTY_NAME + ']"]';
  var ASSET_PROXY_URL = 'https://tortli-artwork-proxy.tortli.workers.dev/image';
  var capturePromise = null;
  var lastFingerprint = '';
  var bypassNextSubmission = false;
  var previewCacheFingerprint = '';
  var previewCacheUrl = '';
  var previewPromise = null;
  var previewPromiseFingerprint = '';
  var scheduledCaptureTimer = null;
  var embeddedFontCssPromises = Object.create(null);

  function setCaptureStatus(state, extra) {
    window.__tortliArtworkCapture = Object.assign({ state: state, updatedAt: Date.now() }, extra || {});
    document.documentElement.dataset.tortliArtworkStatus = state;
    if (extra && extra.error) document.documentElement.dataset.tortliArtworkError = extra.error;
    if (extra && extra.url) document.documentElement.dataset.tortliArtworkUrl = extra.url;
  }

  function getArtworkSvg() {
    var visibleUse = document.querySelector('.tee-printarea-artwork use[href], .tee-printarea-artwork use[xlink\\:href]');
    var reference = visibleUse && (visibleUse.getAttribute('href') || visibleUse.getAttribute('xlink:href'));
    var referenced = reference && reference.charAt(0) === '#' ? document.getElementById(reference.slice(1)) : null;
    if (referenced && referenced.matches('svg.tee-mockup-artwork')) return referenced;

    var candidates = Array.prototype.slice.call(document.querySelectorAll('svg.tee-mockup-artwork'));
    return candidates.find(function (svg) {
      return svg.querySelector('image, text, path');
    }) || null;
  }

  function getProductForm() {
    var actions = document.getElementById('teeFormActions');
    var button = actions && actions.querySelector('.tee-form-atc-wrapper button, .tee-form-atc-wrapper [type="submit"]');
    if (button && button.form) return button.form;
    if (button) {
      var formId = button.getAttribute('form');
      if (formId && document.getElementById(formId)) return document.getElementById(formId);
    }

    var forms = Array.prototype.slice.call(document.querySelectorAll('form[action*="/cart/add"]'));
    return forms.find(function (form) {
      return form.offsetParent !== null && form.querySelector('[name="id"]');
    }) || forms[0] || null;
  }

  function getAddButton(form) {
    var actions = document.getElementById('teeFormActions');
    var button = actions && actions.querySelector('.tee-form-atc-wrapper button, .tee-form-atc-wrapper [type="submit"]');
    if (button) return button;
    return form && form.querySelector('[type="submit"]');
  }

  function ensurePropertyInput(form) {
    if (!form) return null;
    var input = form.querySelector(PROPERTY_SELECTOR);
    if (!input) {
      input = document.createElement('input');
      input.type = 'hidden';
      input.name = 'properties[' + PROPERTY_NAME + ']';
      input.dataset.tortliArtworkProperty = 'true';
      form.appendChild(input);
    }
    return input;
  }

  function fingerprint(svg) {
    var source = svg ? svg.outerHTML : '';
    var hash = 2166136261;
    for (var index = 0; index < source.length; index += 1) {
      hash ^= source.charCodeAt(index);
      hash += (hash << 1) + (hash << 4) + (hash << 7) + (hash << 8) + (hash << 24);
    }
    return (hash >>> 0).toString(36);
  }

  function blobToDataUrl(blob) {
    return new Promise(function (resolve, reject) {
      var reader = new FileReader();
      reader.onload = function () { resolve(reader.result); };
      reader.onerror = reject;
      reader.readAsDataURL(blob);
    });
  }

  function isProxyEligibleAsset(url) {
    try {
      var parsedUrl = new URL(url);
      return (
        (parsedUrl.hostname === 's3.wasabisys.com' && parsedUrl.pathname.indexOf('/teeinblue-cdn-ws/customers/uploads/') === 0)
        || (parsedUrl.hostname === 's3.eu-central-2.wasabisys.com' && parsedUrl.pathname.indexOf('/teeinblue-cdn-we/customers/uploads/') === 0)
        || (parsedUrl.hostname === 's3.ap-southeast-1.wasabisys.com' && parsedUrl.pathname.indexOf('/teeinblue-cdn-wa/customers/uploads/') === 0)
      );
    } catch (error) {
      return false;
    }
  }

  function fetchAsset(url) {
    function fetchThroughProxy() {
      return fetch(ASSET_PROXY_URL + '?url=' + encodeURIComponent(url), {
        credentials: 'omit',
        mode: 'cors',
        headers: { 'Accept': 'image/*' }
      });
    }

    return fetch(url, { credentials: 'omit', mode: 'cors' }).then(function (response) {
      if (!response.ok && isProxyEligibleAsset(url)) return fetchThroughProxy();
      return response;
    }).catch(function (error) {
      if (!isProxyEligibleAsset(url)) throw error;
      return fetchThroughProxy();
    });
  }

  function fetchAsDataUrl(url) {
    return fetchAsset(url)
      .then(function (response) {
        if (!response.ok) throw new Error('asset fetch failed');
        return response.blob();
      })
      .then(blobToDataUrl);
  }

  function inlineImages(svg) {
    var images = Array.prototype.slice.call(svg.querySelectorAll('image'));
    return Promise.all(images.map(function (image) {
      var source = image.getAttribute('href') || image.getAttribute('xlink:href');
      if (!source || source.indexOf('data:') === 0) return Promise.resolve();
      return fetchAsDataUrl(source).then(function (dataUrl) {
        image.setAttribute('href', dataUrl);
        image.setAttributeNS('http://www.w3.org/1999/xlink', 'xlink:href', dataUrl);
      });
    }));
  }

  function normalizeFamily(value) {
    return String(value || '').replace(/["']/g, '').trim().toLowerCase();
  }

  function getUsedFontFamilies(svg) {
    var families = [];
    Array.prototype.forEach.call(svg.querySelectorAll('text'), function (text) {
      var family = normalizeFamily(text.getAttribute('font-family'));
      if (family && families.indexOf(family) === -1) families.push(family);
    });
    return families;
  }

  function inlineFonts(svg) {
    var families = getUsedFontFamilies(svg);
    if (!families.length) return Promise.resolve();

    return Promise.all(families.map(function (family) {
      if (embeddedFontCssPromises[family]) return embeddedFontCssPromises[family];
      var googleFamily = encodeURIComponent(family).replace(/%20/g, '+');
      var cssUrl = 'https://fonts.googleapis.com/css2?family=' + googleFamily + ':wght@400;500;600;700&display=swap';
      embeddedFontCssPromises[family] = fetch(cssUrl, { credentials: 'omit', mode: 'cors' })
        .then(function (response) { return response.ok ? response.text() : ''; })
        .then(function (css) {
          var urls = [];
          css.replace(/url\((['"]?)([^)'"\s]+)\1\)/gi, function (match, quote, url) {
            if (url.indexOf('data:') !== 0) urls.push(url);
            return match;
          });
          return Promise.all(urls.map(function (url) {
            return fetchAsDataUrl(url).then(function (dataUrl) {
              css = css.split(url).join(dataUrl);
            });
          })).then(function () { return css; });
        })
        .catch(function () {
          delete embeddedFontCssPromises[family];
          return '';
        });
      return embeddedFontCssPromises[family];
    })).then(function (embeddedFaces) {
      embeddedFaces = embeddedFaces.filter(Boolean);
      if (!embeddedFaces.length) return;
      var style = document.createElementNS('http://www.w3.org/2000/svg', 'style');
      style.textContent = embeddedFaces.join('\n');
      svg.insertBefore(style, svg.firstChild);
    });
  }

  function svgToPng(svg, maxLongestSide) {
    var viewBox = (svg.getAttribute('viewBox') || '0 0 1000 1000').trim().split(/[ ,]+/).map(Number);
    var sourceWidth = viewBox[2] || 1000;
    var sourceHeight = viewBox[3] || 1000;
    var longestSide = Math.max(sourceWidth, sourceHeight);
    var targetLongestSide = maxLongestSide || 1400;
    var scale = Math.min(1.5, targetLongestSide / longestSide);
    var width = Math.max(1, Math.round(sourceWidth * scale));
    var height = Math.max(1, Math.round(sourceHeight * scale));

    svg.setAttribute('xmlns', 'http://www.w3.org/2000/svg');
    svg.setAttribute('xmlns:xlink', 'http://www.w3.org/1999/xlink');
    svg.setAttribute('width', String(width));
    svg.setAttribute('height', String(height));

    var markup = new XMLSerializer().serializeToString(svg);
    var svgBlob = new Blob([markup], { type: 'image/svg+xml;charset=utf-8' });
    var objectUrl = URL.createObjectURL(svgBlob);

    return new Promise(function (resolve, reject) {
      var image = new Image();
      image.onload = function () {
        try {
          var canvas = document.createElement('canvas');
          canvas.width = width;
          canvas.height = height;
          var context = canvas.getContext('2d');
          context.clearRect(0, 0, width, height);
          context.drawImage(image, 0, 0, width, height);
          canvas.toBlob(function (blob) {
            URL.revokeObjectURL(objectUrl);
            if (blob) resolve(blob);
            else reject(new Error('PNG export failed'));
          }, 'image/png', 0.95);
        } catch (error) {
          URL.revokeObjectURL(objectUrl);
          reject(error);
        }
      };
      image.onerror = function () {
        URL.revokeObjectURL(objectUrl);
        reject(new Error('SVG render failed'));
      };
      image.src = objectUrl;
    });
  }

  function findUploadedUrl(value) {
    if (!value) return '';
    if (typeof value === 'string') {
      if (/^(https?:|ws:|we:|wa:)/i.test(value)) return value;
      return '';
    }
    if (Array.isArray(value)) {
      for (var index = 0; index < value.length; index += 1) {
        var arrayUrl = findUploadedUrl(value[index]);
        if (arrayUrl) return arrayUrl;
      }
      return '';
    }
    var preferredKeys = ['original', 'url', 'image_url', 'imageUrl', 'path', 'file'];
    for (var keyIndex = 0; keyIndex < preferredKeys.length; keyIndex += 1) {
      var preferredUrl = findUploadedUrl(value[preferredKeys[keyIndex]]);
      if (preferredUrl) return preferredUrl;
    }
    var keys = Object.keys(value);
    for (var objectIndex = 0; objectIndex < keys.length; objectIndex += 1) {
      var nestedUrl = findUploadedUrl(value[keys[objectIndex]]);
      if (nestedUrl) return nestedUrl;
    }
    return '';
  }

  function resolveUploadedUrl(url) {
    if (/^https?:/i.test(url)) return url;
    if (url.indexOf('ws:') === 0) return 'https://s3.wasabisys.com/teeinblue-cdn-ws/' + url.slice(3).replace(/^\//, '');
    if (url.indexOf('we:') === 0) return 'https://s3.eu-central-2.wasabisys.com/teeinblue-cdn-we/' + url.slice(3).replace(/^\//, '');
    if (url.indexOf('wa:') === 0) return 'https://s3.ap-southeast-1.wasabisys.com/teeinblue-cdn-wa/' + url.slice(3).replace(/^\//, '');
    return 'https://cdn.teeinblue.com/' + url.replace(/^\//, '');
  }

  function createDeviceFingerprint() {
    var canvas = document.createElement('canvas');
    var context = canvas.getContext('2d');
    context.textBaseline = 'top';
    context.font = '14px Arial';
    context.fillText('Browser fingerprint', 2, 2);
    var source = [
      navigator.userAgent,
      navigator.language,
      screen.width + 'x' + screen.height,
      new Date().getTimezoneOffset(),
      navigator.hardwareConcurrency || 0,
      navigator.deviceMemory || 0,
      canvas.toDataURL()
    ].join('|');
    var hash = 0;
    for (var index = 0; index < source.length; index += 1) {
      hash = (hash << 5) - hash + source.charCodeAt(index);
      hash &= hash;
    }
    return Math.abs(hash).toString(16).padStart(8, '0').repeat(4);
  }

  function uploadArtwork(blob) {
    var formData = new FormData();
    formData.append('file', blob, 'tortli-personalizacja.png');
    var campaign = window.teeinblueCampaign || {};
    if (campaign.id) formData.append('campaign_id', String(campaign.id));
    if (campaign.platform_product_id || campaign.product_id) {
      formData.append('platform_product_id', String(campaign.platform_product_id || campaign.product_id));
    }

    var shop = window.Shopify && window.Shopify.shop ? window.Shopify.shop : 'petshello.myshopify.com';
    var endpoint = 'https://photo-api.teeinblue.com/api/merchant/shopify/photo-upload?shop=' + encodeURIComponent(shop);
    return fetch(endpoint, {
      method: 'POST',
      body: formData,
      credentials: 'omit',
      mode: 'cors',
      headers: {
        'Accept': 'application/json',
        'X-Thumbmark-ID': createDeviceFingerprint()
      }
    })
      .then(function (response) {
        if (response.ok) return response.json();
        return response.text().then(function (message) {
          throw new Error('artwork upload failed (' + response.status + '): ' + message.slice(0, 160));
        });
      })
      .then(function (body) {
        var url = findUploadedUrl(body);
        if (!url) throw new Error('artwork URL missing');
        return resolveUploadedUrl(url);
      });
  }

  function captureArtwork(force) {
    var svg = getArtworkSvg();
    var form = getProductForm();
    if (!svg) return Promise.resolve('');

    var currentFingerprint = fingerprint(svg);
    var input = form && ensurePropertyInput(form);
    if (!force && input && input.value && input.dataset.artworkFingerprint === currentFingerprint) {
      return Promise.resolve(input.value);
    }
    if (capturePromise && lastFingerprint === currentFingerprint) return capturePromise;

    lastFingerprint = currentFingerprint;
    var clone = svg.cloneNode(true);
    clone.removeAttribute('id');
    setCaptureStatus('preparing', { fingerprint: currentFingerprint });
    capturePromise = Promise.resolve(document.fonts && document.fonts.ready)
      .then(function () { return Promise.all([inlineImages(clone), inlineFonts(clone)]); })
      .then(function () {
        setCaptureStatus('rendering', { fingerprint: currentFingerprint });
        return svgToPng(clone);
      })
      .then(function (blob) {
        setCaptureStatus('uploading', { fingerprint: currentFingerprint, bytes: blob.size });
        return uploadArtwork(blob);
      })
      .then(function (url) {
        if (fingerprint(getArtworkSvg()) !== currentFingerprint) return '';
        if (input) {
          input.value = url;
          input.dataset.artworkFingerprint = currentFingerprint;
        }
        setCaptureStatus('ready', { fingerprint: currentFingerprint, url: url });
        document.dispatchEvent(new CustomEvent('tortli:artwork-ready', { detail: { url: url } }));
        return url;
      })
      .catch(function (error) {
        setCaptureStatus('error', { fingerprint: currentFingerprint, error: String(error && error.message || error) });
        console.warn('[Tortli] Nie udało się zapisać samej grafiki personalizacji.', error);
        return '';
      })
      .finally(function () { capturePromise = null; });
    return capturePromise;
  }

  function createArtworkPreview() {
    var svg = getArtworkSvg();
    if (!svg) return Promise.resolve('');
    var currentFingerprint = fingerprint(svg);
    if (previewCacheFingerprint === currentFingerprint && previewCacheUrl) {
      return Promise.resolve(previewCacheUrl);
    }
    if (previewPromise && previewPromiseFingerprint === currentFingerprint) return previewPromise;
    var clone = svg.cloneNode(true);
    clone.removeAttribute('id');
    previewPromiseFingerprint = currentFingerprint;
    var currentPromise = Promise.resolve(document.fonts && document.fonts.ready)
      .then(function () { return Promise.all([inlineImages(clone), inlineFonts(clone)]); })
      .then(function () { return svgToPng(clone, 480); })
      .then(blobToDataUrl)
      .then(function (url) {
        previewCacheFingerprint = currentFingerprint;
        previewCacheUrl = url;
        return url;
      })
      .catch(function () { return ''; })
      .finally(function () {
        if (previewPromise === currentPromise) previewPromise = null;
      });
    previewPromise = currentPromise;
    return currentPromise;
  }

  function scheduleCapture() {
    var form = getProductForm();
    var input = form && ensurePropertyInput(form);
    var svg = getArtworkSvg();
    if (input && svg && input.dataset.artworkFingerprint !== fingerprint(svg)) input.value = '';
    window.clearTimeout(scheduledCaptureTimer);
    if (!svg) return;

    // Prepare the cart artwork while the buyer is still personalizing. The
    // add-to-cart click can then reuse the uploaded URL instead of starting a
    // costly SVG -> PNG -> upload pipeline at the last possible moment.
    scheduledCaptureTimer = window.setTimeout(function () {
      captureArtwork(false);
    }, 450);
  }

  function injectArtworkIntoCartRequest(input, init) {
    var requestUrl = typeof input === 'string' ? input : input && input.url;
    if (!requestUrl || requestUrl.indexOf('/cart/add') === -1 || !init || !init.body) return init;

    var form = getProductForm();
    var propertyInput = form && ensurePropertyInput(form);
    var artworkUrl = propertyInput && propertyInput.value;
    if (!artworkUrl) return init;

    if (init.body instanceof FormData) {
      if (init.body.get('properties[_tortli_cart_addon]') === 'true') return init;
      init.body.set('properties[' + PROPERTY_NAME + ']', artworkUrl);
      return init;
    }

    if (typeof init.body !== 'string') return init;
    try {
      var payload = JSON.parse(init.body);
      var items = Array.isArray(payload.items) ? payload.items : [payload];
      items.forEach(function (item) {
        item.properties = item.properties || {};
        if (item.properties._tortli_cart_addon === 'true') return;
        item.properties[PROPERTY_NAME] = artworkUrl;
      });
      init.body = JSON.stringify(payload);
    } catch (error) {
      // Non-JSON cart payloads are left unchanged.
    }
    return init;
  }

  if (!window.__tortliArtworkFetchPatched) {
    var originalFetch = window.fetch.bind(window);
    window.fetch = function (input, init) {
      return originalFetch(input, injectArtworkIntoCartRequest(input, init));
    };
    window.__tortliArtworkFetchPatched = true;
  }

  function continueSubmission(button, form) {
    bypassNextSubmission = true;
    if (button) button.click();
    else if (form && typeof form.requestSubmit === 'function') form.requestSubmit();
    window.setTimeout(function () { bypassNextSubmission = false; }, 0);
  }

  document.addEventListener('click', function (event) {
    var button = event.target.closest('#teeFormActions .tee-form-atc-wrapper button, #teeFormActions .tee-form-atc-wrapper [type="submit"]');
    if (!button || bypassNextSubmission || !getArtworkSvg()) return;
    var form = button.form || getProductForm();
    var input = form && ensurePropertyInput(form);
    var currentFingerprint = fingerprint(getArtworkSvg());
    if (input && input.value && input.dataset.artworkFingerprint === currentFingerprint) return;

    event.preventDefault();
    event.stopImmediatePropagation();
    var wasDisabled = button.disabled;
    button.disabled = true;
    captureArtwork(true).finally(function () {
      button.disabled = wasDisabled;
      continueSubmission(button, form);
    });
  }, true);

  document.addEventListener('submit', function (event) {
    var form = getProductForm();
    if (!form || event.target !== form || bypassNextSubmission || !getArtworkSvg()) return;
    var input = ensurePropertyInput(form);
    var currentFingerprint = fingerprint(getArtworkSvg());
    if (input.value && input.dataset.artworkFingerprint === currentFingerprint) return;

    event.preventDefault();
    event.stopImmediatePropagation();
    var button = getAddButton(form);
    captureArtwork(true).finally(function () { continueSubmission(button, form); });
  }, true);

  var observedArtwork = null;
  var artworkObserver = new MutationObserver(scheduleCapture);

  function bindArtworkObserver() {
    var artwork = getArtworkSvg();
    if (!artwork || artwork === observedArtwork) return;
    artworkObserver.disconnect();
    observedArtwork = artwork;
    artworkObserver.observe(artwork, { childList: true, subtree: true, attributes: true, characterData: true });
    scheduleCapture();
  }

  var discoveryObserver = new MutationObserver(bindArtworkObserver);
  var discoveryRoot = document.querySelector('main') || document.body || document.documentElement;
  discoveryObserver.observe(discoveryRoot, { childList: true, subtree: true });
  bindArtworkObserver();
  window.setTimeout(bindArtworkObserver, 500);
  window.setTimeout(bindArtworkObserver, 2000);
  window.setTimeout(function () { discoveryObserver.disconnect(); }, 30000);
  var publicApi = {
    capture: function () { return captureArtwork(false); },
    preview: createArtworkPreview,
    status: function () { return window.__tortliArtworkCapture || null; }
  };
  window.TortliTeeArtworkCapture = publicApi;
  document.documentElement.__tortliArtworkCaptureApi = publicApi;
  document.dispatchEvent(new CustomEvent('tortli:artwork-api-ready', {
    detail: { api: publicApi }
  }));
  document.documentElement.dataset.tortliArtworkApi = 'ready';
})();
